import { Session } from '@rapid-recovery-agency-inc/insightt-shared';

export const FETCH_SESSION = 'SYSTEM/FETCH_SESSION';
/** Action type of `actions.ts`'s `resetSystemScope`; shared here so other slices can react to it without importing `actions.ts`. */
export const RESET_SYSTEM_SCOPE = 'SYSTEM/RESET_SCOPE';
export const ON_ACCEPT_TERM_AND_SERVICE = 'SYSTEM/ON_ACCEPT_TERM_AND_SERVICE';
export const ON_ACCEPT_PRIVACY_POLICY = 'SYSTEM/ON_ACCEPT_PRIVACY_POLICY';
export interface SystemState {
  session: Session;
  loadingAcceptTermOrPrivacyPolicy: boolean;
  /**
   * T031 (FR-042) — the `requestId` of the most recently PENDING `fetchSession` dispatch, kept in
   * state (not module-scope) so the reducer stays a pure function of `(state, action)` — see
   * `reducers.ts`'s `fetchSession.pending`/`fulfilled` cases for how this rejects stale scope
   * publications, and why a module-scope variable would break Redux's single-source-of-truth
   * guarantee across multiple store instances (e.g. per-test stores).
   */
  latestFetchSessionRequestId: string | null;
}

export interface FetchSessionResponse {
  session: Session;
}

export type CompanySettingUserAllowed = {
  id: number;
  name: string;
};

export type CompanySettingRoleAllowed = {
  id: number;
  name: string;
};
